module.exports = __webpack_public_path__ + "img/poster-webinar-bg.49d25d82.png";